var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3047 23.5069C8.40148 23.4901 6 17.5637 6 14.5455C6 9.61531 9.69849 8.53596 11.1239 8.53596C11.7662 8.53596 12.4521 8.78821 13.0571 9.01144C13.4802 9.16715 13.9177 9.32789 14.161 9.32789C14.3067 9.32789 14.6499 9.19115 14.953 9.07118C15.5992 8.81389 16.4034 8.49413 17.3399 8.49413C17.3416 8.49413 17.3438 8.49413 17.3455 8.49413C18.0448 8.49413 20.165 8.64759 21.4397 10.5619L21.7383 11.0105L21.3085 11.3348C20.6946 11.798 19.5745 12.643 19.5745 14.3167C19.5745 16.2991 20.8431 17.0614 21.4525 17.4281C21.7215 17.59 22 17.7568 22 18.1218C22 18.3601 20.098 23.4773 17.336 23.4773C16.6602 23.4773 16.1824 23.2741 15.761 23.095C15.3347 22.9136 14.9669 22.7574 14.3591 22.7574C14.051 22.7574 13.6615 22.903 13.249 23.0576C12.6854 23.268 12.0475 23.5069 11.3237 23.5069H11.3047Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6325 4C17.7045 6.59365 15.8496 8.393 13.9969 8.28015C13.6916 6.21033 15.8494 4 17.6325 4Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginApple);
export default __webpack_public_path__ + "static/media/login-apple.fc4917efa2b4a9e546ede197a7e8f92b.svg";
export { ForwardRef as ReactComponent };